import React from "react";
import "./BusinessbayWall.css";
import businessbaywall from "../../Images/businessbaywalllogo.png";

function BusinessbayWall() {
  return (
    <div className="businessbay-container">
      <div className="businessbay-playground">
        <div className="businessbay-left-content">
          <span className="badge">Businessbay Wall</span>
          <h1 className="businessbay-h1">
           
            Your Success Timeline in One Scroll
          </h1>
          <p className="businessbay-p">
           
            From your first viral post to your latest collaboration, curate your
            journey for brands to follow.
          </p>
        </div>
        <div className="businessbay-right-image">
          <img
            src={businessbaywall}
            className="businessbay-right-image-inner"
            alt="businessbaywall"
          />
        </div>
      </div>
    </div>
  );
}

export default BusinessbayWall;
